
import Vue from 'vue';
import MISC_DATA from '@/store/modules/MiscDataModule';

export default Vue.extend({
	name: 'PartnerInfoSection',

	computed: {
		MISC_DATA: () => MISC_DATA,

		isMobile(): boolean {
			return this.$vuetify.breakpoint.smAndDown;
		}
	}
});
